// extracted by mini-css-extract-plugin
export default {"presentationViewport":"NLOb2__presentationViewport presentation-viewport"};